import { NgModule } from '@angular/core';
import { SuperSavingsComponent } from './super-savings.component';

@NgModule({
  declarations: [SuperSavingsComponent],
  exports: [SuperSavingsComponent],
})
export class SuperSavingsModule {}
